export default "__VITE_ASSET__BdnQZ5d___"